//@ts-nocheck
import { Box, BoxProps, ColorOptions, Spacer, Text, TextProps } from '@jfs/ui-new'
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs'
import { NavigationContainer, NavigationIndependentTree } from '@react-navigation/native'
import { FC, useEffect, useRef, useState } from 'react'
import { AccordionList } from '../../comps/AccordionList'
import { Button } from '../../comps/Button'
import { Modal } from '../../comps/Modal'
import { ModalHeader } from '../../comps/ModalHeader'
import { useLazyApiData, useStores } from '../../data/store'
import { convertHexToRGBA, formatAmount, isIE } from '../../utils'
import { EMI, EMI_SCHME_TYPE, OFFER_TYPE, PAYMENT_MODE_SUBTYPES, PAYMENT_MODE_TYPE } from '../../utils/constants'
import { TabBar } from './TabBar'

const CardEMIPlans: FC<{
  theme: any
  bankId?: any
  cardNo: string
  schemeSubType: string
  onEMIPlanSelected: (emi: any, isOfferApplied: boolean) => void
  onDismiss: () => void
}> = ({ theme, bankId, cardNo, onEMIPlanSelected, onDismiss, schemeSubType }) => {
  const {
    validateOffer,
    getCardEligibility,
    payableAmount,
    offerApplied,
    isValidBankEMIId,
    amount,
    getCardEMIPlans,
    updateIsValidOffer,
  } = useStores((root) => ({
    validateOffer: root.offerValidateApi,
    getCardEligibility: root.getCardOfferEMIEligibility,
    payableAmount: root.getTransactionAmount(),
    offerApplied: root.isOfferApplied,
    amount: root.transaction.amount.netAmount,
    isValidBankEMIId: root.isValidBankEMIId,
    getCardEMIPlans: root.getCardEMIPlans,
    updateIsValidOffer: root.transaction.updateIsValidOffer,
  }))

  const isOfferApplied = offerApplied(PAYMENT_MODE_SUBTYPES.CARD, PAYMENT_MODE_TYPE.EMI)

  const [isLoading, setIsLoading] = useState(false)
  const tenureRef = useRef<any>()
  const emiplanRef = useRef<any>()

  const [validateOfferApi, { state: validateOfferState, data: validateOfferData }] = useLazyApiData(validateOffer)
  const [lazyGetCardEligibility, { state: getCardEligibilityState, data: getCardEligibilityData }] =
    useLazyApiData(getCardEligibility)
  useEffect(() => {
    if (validateOfferState === 'fulfilled') {
      const data = validateOfferData
      if (data?.offerType === OFFER_TYPE.INSTANT) {
        const cardBin = cardNo.replace(/[^0-9]/g, '').slice(0, 6)
        lazyGetCardEligibility(cardBin, true, schemeSubType, payableAmount, bankId)
      } else {
        setIsLoading(false)
        console.log('onSelectBrandEMI7', emiplanRef.current)
        onEMIPlanSelected(emiplanRef.current, true)
        onDismiss()
      }
    } else if (validateOfferState === 'rejected') {
      setIsLoading(false)
      console.log('onSelectBrandEMI8', emiplanRef.current)
      onEMIPlanSelected(emiplanRef.current, false)
      onDismiss()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateOfferData, validateOfferState])

  useEffect(() => {
    if (getCardEligibilityState === 'fulfilled') {
      const data = getCardEligibilityData
      const [updatedEMIData] = data.filter((item: any) => item.scheme === tenureRef.current.schemeId)
      setIsLoading(false)
      if (updatedEMIData) {
        const emiObj = { ...updatedEMIData, emi: updatedEMIData.value }
        onEMIPlanSelected(emiObj, true)
      } else {
        onEMIPlanSelected(emiplanRef.current, false)
      }
      onDismiss()
    } else if (getCardEligibilityState === 'rejected') {
      setIsLoading(false)
      updateIsValidOffer(false)
      console.log('onSelectBrandEMI5', emiplanRef.current)
      onEMIPlanSelected(emiplanRef.current, false)
      onDismiss()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getCardEligibilityData, getCardEligibilityState])

  const Tab = createMaterialTopTabNavigator()

  const style = styles(theme)

  const renderHeader = ({ item }: any) => {
    return (
      <>
        <Box {...style.listItemHeading}>
          <Box {...style.row}>
            <Text
              {...style.headerEMIText(
                item.isExpanded,
              )}>{`₹${item.header.emi} X ${item.header.tenure} | ${item.header.interestRate}% p.a`}</Text>
            <Text {...style.headerEMIText(item.isExpanded)}>{`Payable: ₹${Number(item.header.amount).toFixed(
              2,
            )}`}</Text>
          </Box>

          {item.header.instantDiscountPercentage && Number(item.header.instantDiscountPercentage) > 0 && (
            <>
              <Spacer direction="vertical" size={8} />
              <Box>
                <Text {...style.discountText}>
                  {'₹' + formatAmount(item.header.instantDiscountPercentage)} instant Discount applicable
                </Text>
              </Box>
            </>
          )}
        </Box>
        <Spacer direction="vertical" size={10} />
        <Box {...style.separatorStyle} />
      </>
    )
  }

  const emiDetailRowItem = (title: any, value: any, textColor: any) => {
    return (
      <Box flexDirection="row" justifyContent="space-between" pv={8}>
        <Text color={convertHexToRGBA(textColor, 50) as ColorOptions} fontFamily="jioType-medium" fontSize={12}>
          {title}
        </Text>
        <Text color={textColor as ColorOptions} fontFamily="jioType-bold" fontSize={12}>
          {value}
        </Text>
      </Box>
    )
  }

  const onSelectBrandEMI = (item: any) => {
    console.log('onSelectBrandEMI', item)
    emiplanRef.current = item
    updateIsValidOffer(false)
    if (isOfferApplied) {
      if (Number(item.discount) === 0 && isValidBankEMIId(item.bank)) {
        tenureRef.current = {
          schemeId: item.scheme,
        }
        setIsLoading(!isLoading)
        validateOfferApi(
          { card: { number: cardNo }, bankEmiId: item.bank, bankTenure: item.tenure },
          { type: PAYMENT_MODE_TYPE.EMI, subType: PAYMENT_MODE_SUBTYPES.CARD },
        )
      } else {
        console.log('onSelectBrandEMI1', item)
        onEMIPlanSelected(item, false)
        onDismiss()
      }
    } else {
      console.log('onSelectBrandEMI2', item)
      onEMIPlanSelected(item, false)
      onDismiss()
    }
  }
  const nonBrandRenderData = (item: any) => {
    const schemeNote = item.schemeNote.split('$1')
    return (
      <>
        <Box {...style.listEMIData}>
          <Text {...style.costBreakUp}>Cost Breakup</Text>
          <Spacer size={20} />
          <Box {...style.modalDataContainer}>
            <Text {...style.emiBreakupTitle}>Gross Amount</Text>
            <Text {...style.emiBreakupValue}>{`₹${formatAmount(item.grossAmount)}`}</Text>
          </Box>
          <Spacer size={20} />
          <Box {...style.modalDataContainer}>
            <Text {...style.emiBreakupTitle}>{`Interest Payable(${item.interestRate}%)`}</Text>
            <Text {...style.emiBreakupValue}>{`₹${formatAmount(item.interest)}`}</Text>
          </Box>
          <Spacer size={20} />
          <Box {...style.modalDataContainer}>
            <Text {...style.emiBreakupTitle}>Processing fee</Text>
            <Text {...style.emiBreakupValue}>{`₹${formatAmount(item.processingFees.amount)}`}</Text>
          </Box>
          <Spacer size={20} />
          <Box {...style.modalDataContainer}>
            <Text {...style.emiBreakupTitle}>{`Processing fee GST(${item.processingFees.taxPercentage}%)`}</Text>
            <Text {...style.emiBreakupValue}>{`₹${formatAmount(item.processingFees.tax)}`}</Text>
          </Box>
          <Spacer size={20} />
          <Box {...style.modalDataContainer}>
            <Text {...style.emiBreakupTitle}>Convenience fee</Text>
            <Text {...style.emiBreakupValue}>{`₹${formatAmount(item.convenienceFees.amount)}`}</Text>
          </Box>
          <Spacer size={20} />
          <Box {...style.modalDataContainer}>
            <Text {...style.emiBreakupTitle}>{`Convenience fee GST(${item.convenienceFees.taxPercentage}%)`}</Text>
            <Text {...style.emiBreakupValue}>{`₹${formatAmount(item.convenienceFees.tax)}`}</Text>
          </Box>
          <Spacer size={20} />
          <Box {...style.separatorStyle} />
          <Spacer size={20} />
          <Box {...style.modalDataContainer}>
            <Text {...style.totalPayable}>Total Payable</Text>
            <Text {...style.totalPayableAmount}>{`₹${formatAmount(item.totalAmount)}`}</Text>
          </Box>
          <Spacer size={20} />
          <Text {...style.emiBreakupTitle}>
            {schemeNote[0]}
            <Text fontWeight="bold" fontSize={12} color={theme.bodyTextColor}>{`₹${formatAmount(amount)}`}</Text>
            {schemeNote[1]}
          </Text>
          <Spacer size={24} />
          <Button
            isFull={true}
            title="Select Plan"
            isLoading={isLoading}
            testID="select-plan"
            onPress={() => onSelectBrandEMI(item)}
          />
        </Box>
        <Box {...style.separatorStyle} />
      </>
    )
  }
  const brandRenderData = (item: any) => {
    return (
      <>
        {item.emiDetails.map((item: any) => (
          <Box marginTop={8} marginBottom={8} ph={24}>
            {emiDetailRowItem('Product Code', item.productCode, theme?.bodyTextColor)}
            {emiDetailRowItem('Item Value', '₹' + formatAmount(item.itemValue), theme?.bodyTextColor)}
            {emiDetailRowItem('Interest (charge by bank)', '₹' + formatAmount(item.interest), theme?.bodyTextColor)}
            {emiDetailRowItem(
              'EMI Discount/Cashback',
              '₹' + formatAmount(item.subventionCashbackDiscount),
              theme?.bodyTextColor,
            )}
            {item.additionalCashback &&
              emiDetailRowItem('add. Cashback', item.additionalCashback, theme?.bodyTextColor)}
          </Box>
        ))}
        <Box {...style.separatorStyle} marginHorizontal={16} />
        <Spacer size={16} />
        <Box ph={16} flexDirection="row" justifyContent="space-between">
          <Text color={theme.bodyTextColor} fontSize={14} fontWeight="700">
            Total Payable
          </Text>
          <Text color={theme.bodyTextColor} fontSize={14} fontWeight="700">
            {`₹${formatAmount(item.netAmount)}`}
          </Text>
        </Box>
        <Spacer size={24} />
        <Box paddingHorizontal={16} paddingBottom={16}>
          <Button
            isFull={true}
            title="Select EMI Plan"
            testID="select-plan-btn"
            isLoading={false}
            onPress={() => {
              console.log('onSelectBrandEMI4', item)
              emiplanRef.current = item
              updateIsValidOffer(false)
              onEMIPlanSelected(item, false)
              onDismiss()
            }}
          />
        </Box>
      </>
    )
  }

  const renderData = ({ item }: any) => {
    if (item.schemeType === EMI_SCHME_TYPE.EXTERNAL) {
      return brandRenderData(item)
    } else {
      return nonBrandRenderData(item)
    }
  }

  const noCostEMIAvailable =
    getCardEMIPlans(cardNo.replace(/[^0-9]/g, '').slice(0, 6), schemeSubType, EMI.NO_COST_CARD_EMI).length > 0

  const lowCostEMIAvailable =
    getCardEMIPlans(cardNo.replace(/[^0-9]/g, '').slice(0, 6), schemeSubType, EMI.LOW_COST_CARD_EMI).length > 0

  const standardEMIAvailable =
    getCardEMIPlans(cardNo.replace(/[^0-9]/g, '').slice(0, 6), schemeSubType, EMI.STANDARD_CARD_EMI).length > 0

  const modalBodyView = () => {
    return (
      <NavigationIndependentTree>
        <NavigationContainer independent={true}>
          <Tab.Navigator
            screenOptions={{ sceneStyle: { backgroundColor: theme.bodyBgColor } }}
            tabBar={(props) => <TabBar {...props} theme={theme} />}>
            {noCostEMIAvailable && (
              <Tab.Screen
                name="No Cost EMI"
                component={() => (
                  <AccordionList
                    theme={theme}
                    data={getCardEMIPlans(
                      cardNo.replace(/[^0-9]/g, '').slice(0, 6),
                      schemeSubType,
                      EMI.NO_COST_CARD_EMI,
                    )}
                    renderHeader={renderHeader}
                    renderData={renderData}
                  />
                )}
              />
            )}
            {lowCostEMIAvailable && (
              <Tab.Screen
                name="Low Cost EMI"
                component={() => (
                  <AccordionList
                    theme={theme}
                    data={getCardEMIPlans(
                      cardNo.replace(/[^0-9]/g, '').slice(0, 6),
                      schemeSubType,
                      EMI.LOW_COST_CARD_EMI,
                    )}
                    renderHeader={renderHeader}
                    renderData={renderData}
                  />
                )}
              />
            )}
            {standardEMIAvailable && (
              <Tab.Screen
                name="Standard EMI"
                component={() => (
                  <AccordionList
                    theme={theme}
                    data={getCardEMIPlans(
                      cardNo.replace(/[^0-9]/g, '').slice(0, 6),
                      schemeSubType,
                      EMI.STANDARD_CARD_EMI,
                    )}
                    renderHeader={renderHeader}
                    renderData={renderData}
                  />
                )}
              />
            )}
          </Tab.Navigator>
        </NavigationContainer>
      </NavigationIndependentTree>
    )
  }

  return (
    <Modal
      type={'BottomTop'}
      headerType="White_Bg"
      show={true}
      onDismiss={onDismiss}
      theme={theme}
      containerTopPadding={isIE() ? 5 : undefined}>
      <>
        <ModalHeader title="Select EMI Plan" onDismiss={onDismiss} theme={theme} />
        {modalBodyView()}
      </>
    </Modal>
  )
}

const styles = (theme: any) => ({
  listEMIItemHeading: (isSelected: boolean) =>
    ({
      borderBottomWidth: isSelected ? 2 : 0,
      backgroundColor: theme.bodyBgColor as ColorOptions,
      borderBottomColor: theme.brandColor as ColorOptions,
      paddingVertical: 20,
      paddingHorizontal: 16,
      flexDirection: 'row',
      justifyContent: 'space-between',
    } as BoxProps),
  listItemHeading: {
    height: 64,
    paddingHorizontal: 16,
    justifyContent: 'center',
    backgroundColor: theme.bodyBgColor as ColorOptions,
  } as BoxProps,
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  } as BoxProps,
  headerEMIText: (isSelected: boolean) =>
    ({
      fontSize: 12,
      color: isSelected ? theme?.bodyTextColor : (convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions),
      fontWeight: isSelected ? 'bold' : '700',
    } as TextProps),
  separatorStyle: {
    height: 1,
    backgroundColor: convertHexToRGBA(theme?.bodyTextColor, 10) as ColorOptions,
  } as BoxProps,
  listEMIData: {
    padding: 24,
    backgroundColor: convertHexToRGBA(theme?.bodyTextColor, 5) as ColorOptions,
    underlayColor: theme?.bodyBgColor,
  } as BoxProps,
  modalDataContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  } as BoxProps,
  discountText: {
    color: theme.brandColor,
    fontSize: 10,
    fontWeight: 'bold',
  } as TextProps,
  emiBreakupTitle: {
    fontSize: 12,
    color: convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions,
    fontWeight: '700',
  } as TextProps,
  emiBreakupValue: {
    fontSize: 12,
    color: theme?.bodyTextColor as ColorOptions,
    fontWeight: 'bold',
  } as TextProps,
  emiPlans: {
    fontSize: 14,
    color: theme.brandColor as ColorOptions,
    fontWeight: '700',
    textDecorationLine: 'underline',
  } as TextProps,
  costBreakUp: {
    fontSize: 14,
    color: theme?.bodyTextColor as ColorOptions,
    fontWeight: 'bold',
  } as TextProps,
  totalPayable: {
    fontSize: 14,
    color: theme?.bodyTextColor as ColorOptions,
    fontWeight: '700',
  } as TextProps,
  totalPayableAmount: {
    fontSize: 14,
    color: theme?.brandColor as ColorOptions,
    fontWeight: 'bold',
  } as TextProps,
})

export { CardEMIPlans }
